import axios from "axios";

const wadoRoot = () => {
  return `${window.config.dataSources[0].configuration['wadoRoot']}/studies`;
}

export class ImagemService {

  getImagensChave(STUDYUID_FKEY, SERIESUID_FKEY) {
    try {
      return axios.get(`${wadoRoot()}/${STUDYUID_FKEY}/${SERIESUID_FKEY}/getImagesKeyBySeriesLevel`);
    } catch (error) {
      console.log(error);
    }
  }

  async getIsS3(STUDYUID_FKEY) {
    return await axios.get(`${wadoRoot()}/${STUDYUID_FKEY}/isS3`)
      .then(resp => {
        return resp.data;
      })
      .catch(ex => {
        console.error(ex);
      })
  }

  async startDownloadS3(STUDYUID_FKEY) {
    return await axios.get(`${wadoRoot()}/${STUDYUID_FKEY}/getStartDownloadS3`)
      .then(resp => {
        return resp.status === 200;
      })
      .catch(ex => {
        console.error(ex);
      })
  }

  putImageKey(VALUE, STUDYUID_FKEY, SERIESUID_FKEY, INSTANCEUID) {
    try {
      return axios.put(`${wadoRoot()}/${VALUE}/${STUDYUID_FKEY}/${SERIESUID_FKEY}/${INSTANCEUID}/putimagemimpressao`);
    }
    catch (error) {
      console.log(error);
    }
  }

  postImagemSecundaria(imagemSecundariaDTO) {
    try {
      var formdata = new FormData();
      formdata.append('InstanceUid', imagemSecundariaDTO.InstanceUid);
      formdata.append('Image', imagemSecundariaDTO.Image);
      return axios.post(`${wadoRoot()}/postGerarImagemSecundaria`, formdata);
    } catch (error) {
      console.log(error);
    }
  }

}
